export default "__VITE_ASSET__Wnxc7ibd__"